module.exports = __webpack_public_path__ + "static/kentpark-sm-56621c95b9aa15663fa4e7655a75982a.jpg";